"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CONFIG_HTTP_MONITOR = {
    timeoutFirstByte: 1000,
    timeoutLoad: 6000,
    intervalBandwidthEstimate: 500
};
exports.default = CONFIG_HTTP_MONITOR;
//# sourceMappingURL=CONFIG_HTTP_MONITOR.js.map